import { render, staticRenderFns } from "./JustificarHoraExtraPage.vue?vue&type=template&id=20162118"
import script from "./JustificarHoraExtraPage.vue?vue&type=script&lang=js"
export * from "./JustificarHoraExtraPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports